import Button from './form-control/Button';
import { FaAngleLeft } from 'react-icons/fa';

type IBackButton = {
  onClick?: () => void;
};

const BackButton = ({ onClick }: IBackButton) => {
  return (
    <>
      <Button
        label="Back"
        labelClasses='dark:!text-darkBg-mainText'
        className="rounded !py-1 !px-3 border-2 !border-primary-main hover:bg-primary-main "
        icon={<FaAngleLeft className="h-4 w-4 dark:text-darkBg-mainText" />}
        curved
        onClick={onClick}
      />
    </>
  );
};

export default BackButton;
